export default __webpack_public_path__ + "static/media/discipline-hospitality.b6e90d88.svg";